import { InputNumber, Modal, Space } from 'antd';
import React, { FC, useState } from 'react';
import styles from './index.less';

const SetDuration: FC<{ onSubmit: (duration: number) => void }> = ({ onSubmit }) => {
  const [time, setTime] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [visible, setVisible] = useState<boolean>(false);
  const setTimeNum = (field: 'hours' | 'minutes' | 'seconds', value: number) => {
    setTime((prevState) => {
      return { ...prevState, [field]: value };
    });
  };
  return (
    <>
      <span
        onClick={() => {
          setVisible(true);
        }}
        className={styles.set_duration_com}
      >
        点击手动设置时长
      </span>
      <Modal
        title="设置时长"
        open={visible}
        onCancel={() => {
          setVisible(false);
        }}
        centered
        onOk={() => {
          const duration = time.hours * 3600 + time.minutes * 60 + time.seconds;
          onSubmit(duration);
        }}
      >
        <Space>
          <InputNumber
            onChange={(value) => {
              setTimeNum('hours', value || 0);
            }}
            value={time.hours}
            min={0}
            defaultValue={0}
            precision={0}
          />
          <span>时</span>
          <InputNumber
            onChange={(value) => {
              setTimeNum('minutes', value || 0);
            }}
            value={time.minutes}
            min={0}
            defaultValue={0}
            precision={0}
            max={60}
          />
          <span>分</span>
          <InputNumber
            onChange={(value) => {
              setTimeNum('seconds', value || 0);
            }}
            value={time.seconds}
            min={0}
            defaultValue={0}
            precision={0}
            max={60}
          />
          <span>秒</span>
        </Space>
      </Modal>
    </>
  );
};
export default SetDuration;
